import React from 'react';
import { Home, Activity, User } from 'lucide-react';
interface BottomNavProps {
  activeTab: 'home' | 'activity' | 'account';
  onTabChange: (tab: 'home' | 'activity' | 'account') => void;
}
export function BottomNav({
  activeTab,
  onTabChange
}: BottomNavProps) {
  return <div className="absolute bottom-0 left-0 right-0 z-30 border-t border-slate-100 bg-white pb-6 pt-3 px-6" data-id="element-63">
      <div className="flex items-center justify-between" data-id="element-64">
        <button onClick={() => onTabChange('home')} className={`flex flex-col items-center gap-1 ${activeTab === 'home' ? 'text-blue-600' : 'text-slate-400'}`} data-id="element-65">
          <Home className="h-6 w-6" strokeWidth={activeTab === 'home' ? 2.5 : 2} data-id="element-66" />
          <span className="text-[10px] font-medium" data-id="element-67">Home</span>
        </button>

        <button onClick={() => onTabChange('activity')} className={`flex flex-col items-center gap-1 ${activeTab === 'activity' ? 'text-blue-600' : 'text-slate-400'}`} data-id="element-68">
          <Activity className="h-6 w-6" strokeWidth={activeTab === 'activity' ? 2.5 : 2} data-id="element-69" />
          <span className="text-[10px] font-medium" data-id="element-70">Activity</span>
        </button>

        <button onClick={() => onTabChange('account')} className={`flex flex-col items-center gap-1 ${activeTab === 'account' ? 'text-blue-600' : 'text-slate-400'}`} data-id="element-71">
          <User className="h-6 w-6" strokeWidth={activeTab === 'account' ? 2.5 : 2} data-id="element-72" />
          <span className="text-[10px] font-medium" data-id="element-73">Account</span>
        </button>
      </div>
    </div>;
}